document.addEventListener('DOMContentLoaded', () => {
    const tolerance = 3; // допустимая разница в px
  
    document.querySelectorAll('.custom-scroll').forEach(s => {
        const parentHeight = s.parentElement.clientHeight;
        const parentWidth = s.parentElement.clientWidth;
        if (s.clientHeight - parentHeight > tolerance && s.clientWidth - parentWidth < tolerance) {
            new PerfectScrollbar(s, { suppressScrollY: false });
        } else if (s.clientWidth - parentWidth > tolerance && s.clientHeight - parentHeight > tolerance) {
            new PerfectScrollbar(s, { suppressScrollY: true });
        }
    });
  
    document.querySelectorAll('.custom-scroll-y').forEach(s => {
        if (s.scrollWidth - s.clientWidth > tolerance) {
            new PerfectScrollbar(s, { suppressScrollY: true });
        }
    });
});
  